export const POLINI_MINISET_PROMO_ITEMS = [
  {
    slug: 'miniset-672',
    model: '672',
    name: 'Miniset Polini 672',
    shortName: 'Miniset 672',
    href: '/produk/bra-wa-130-miniset-672-polini',
    imageUrl: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/10/15/38468f6a916c4fd69902067196235b1d.jpeg',
    alt: 'Pilihan warna Miniset Polini 672',
    detail: 'Model sporty, ukuran M sampai XL',
  },
  {
    slug: 'miniset-673',
    model: '673',
    name: 'Miniset Polini 673',
    shortName: 'Miniset 673',
    href: '/produk/miniset-673-polini-in',
    imageUrl: 'https://s3.us-east-2.amazonaws.com/8grams-vorme/704f03f1-2dce-4e83-827e-349562728803/2026/10/15/39ac01001eef4d35bf0109915c698ae5.jpeg',
    alt: 'Pilihan warna Miniset Polini 673',
    detail: 'Model racerback, warna mengikuti stok',
  },
] as const
